/**
 * Safely parse JSON strings with fallback handling
 * @param {any} jsonString - The value to parse
 * @param {any} fallback - The fallback value if parsing fails (default: [])
 * @returns {any} Parsed JSON or fallback value
 */
export const safeJSONParse = (jsonString, fallback = []) => {
  console.log("safeJSONParse - Input:", jsonString, "Type:", typeof jsonString);

  if (!jsonString) {
    console.log("safeJSONParse - Empty input, returning fallback");
    return fallback;
  }

  // If it's already an object/array, return it
  if (typeof jsonString === "object") {
    console.log("safeJSONParse - Already an object, returning as-is");
    return jsonString;
  }

  if (typeof jsonString !== "string") {
    console.log("safeJSONParse - Not a string, returning fallback");
    return fallback;
  }

  const trimmed = jsonString.trim();

  if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
    try {
      const parsed = JSON.parse(jsonString);
      console.log("safeJSONParse - Parsed JSON:", parsed);
      return parsed;
    } catch (error) {
      console.error("Failed to parse JSON:", error, "Input:", jsonString);
      return fallback;
    }
  }


  if (trimmed.length > 0) {
    const result = [{ id: Date.now(), text: trimmed, isEditing: false }];
    console.log("safeJSONParse - Converted plain string to array:", result);
    return result;
  }

  console.log("safeJSONParse - Empty string, returning fallback");
  return fallback;
};
